export default "__VITE_ASSET__BSniOuhM__"